import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import React from 'react';
import classNames from 'classnames';

type EcoScrollTableProps = {
    totalPages?: number;
};

export const EcoScrollTable: React.FC<EcoScrollTableProps> = ({
    totalPages,
}) => {
    const scrollEndTable = React.useCallback(() => {
        const antTableContent = document.querySelector('.ant-table-content');
        antTableContent?.scrollTo({
            left: 1000,
            behavior: 'smooth',
        });
    }, []);

    const scrollLeftTable = React.useCallback(() => {
        const antTableContent = document.querySelector('.ant-table-content');
        antTableContent?.scrollTo({
            left: -1000,
            behavior: 'smooth',
        });
    }, []);

    const renderTotalPages = () => {
        if (!totalPages) {
            return null;
        }
        const totalPagesFormatted = new Intl.NumberFormat().format(totalPages);
        return (
            <div className="flex pl-3 font-medium">
                Total: {totalPagesFormatted}
            </div>
        );
    };

    return (
        <div
            className={classNames([
                'flex flex-row items-center w-full',
                {
                    'justify-between': totalPages,
                    'justify-end': !totalPages,
                },
            ])}
        >
            {!!totalPages && <div>{renderTotalPages()}</div>}
            <div className="flex items-center justify-end">
                <div className="flex flex-row items-center">
                    <Button type="link" onClick={scrollLeftTable}>
                        <LeftOutlined />
                    </Button>
                </div>
                <div className="flex flex-row items-center">
                    <Button type="link" onClick={scrollEndTable}>
                        <RightOutlined />
                    </Button>
                </div>
            </div>
        </div>
    );
};
